
import Vue from "vue";
// import firebase from "firebase/compat/app";
import "firebase/compat/messaging";
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
export default Vue.extend({
  name: "App",
  // script firebase
  // data: () => ({
  //   //
  //   notificationAlertState: false,
  //   notificationAlertTitle: "",
  //   notificationAlertBody: "",
  //   tokenFcm: "",
  // }),

  // created() {
  //   firebase.messaging().getToken();
  //   // .then((token) => {
  //   //   console.log("token firebase", token);
  //   //   // TODO save token to backend
  //   //   // this.tokenFcm = token;
  //   //   // this.receiveMessage();
  //   // })
  //   // .catch((err: any) => {
  //   //   // console.log(err);
  //   //   this.$swal("Error", err?.response?.data?.message, "error");
  //   // });
  //   firebase.messaging().onMessage((payload) => {
  //     // TODO show notification
  //     // console.log("payload", payload);
  //     // this.notificationAlertTitle = "test";
  //     // this.notificationAlertBody = "test";
  //     this.notificationAlertTitle = payload.notification.title;
  //     this.notificationAlertBody = payload.notification.body;
  //     this.notificationAlertState = true;
  //   });
  // },
  // methods: {
  //   // receiveMessage() {
  //   //   try {
  //   //     firebase.messaging().onMessage(() => {
  //   //       // console.log("payload ", payload);
  //   //       // this.showToast(payload);
  //   //     });
  //   //   } catch (e) {
  //   //   }
  //   // },
  //   // showToast(payload) {
  //   //   this.$toast.open({
  //   //     message: payload.notification.body,
  //   //     position: "top-right",
  //   //     type: "info",
  //   //     onClick: () => {
  //   //       window.location = payload.notification.click_action;
  //   //     },
  //   //   });
  //   // },
  // },
});
